import { GRAPH_TYPE } from "../common/constants";

const DEFAULT_GRAPH_TYPE = GRAPH_TYPE.tree;

const topPanelInitial = {
    height: 0,
    expanded: true,
    graphType: DEFAULT_GRAPH_TYPE,
    isProfi: true,
    linkLabels: true,
}

const initialState = {
    topPanel: { ...topPanelInitial },
    profiles: {},
}

export {
    DEFAULT_GRAPH_TYPE,
    topPanelInitial, initialState as topPanelInitialState
};
